import { HttpContextToken, HttpHandlerFn, HttpInterceptorFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { transformarFechasFormatoAISO } from '../utils/fechas-utils';
import { map } from 'rxjs/operators';

// Opt out when the source parser already supplies the canonical API date contract.
// Keep legacy callers compatible until their input formats are explicitly migrated.
export const FECHAS_NORMALIZADAS = new HttpContextToken<boolean>(() => false);

export const fechasInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn) => {
  if (req.context.get(FECHAS_NORMALIZADAS)) return next(req);
  
  let body = req.body;
  if (body && !(body instanceof FormData)) {
      body = transformarFechasFormatoAISO(body);
  }

  const clonedReq = req.clone({ body });

  return next(clonedReq).pipe(
      map((event) => {
          if (event instanceof HttpResponse && event.body && typeof event.body === 'object') {
              const newBody = transformarFechasFormatoAISO(event.body);
              return event.clone({ body: newBody });
          }
          return event;
      })
  );
}
